import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import Layout from './Layout';
import { XCircleIcon } from'@heroicons/react/solid';
import { CheckCircleIcon } from '@heroicons/react/solid';
import { verifyPasswordReset, resetPassword } from './apiCore';
import SuccessModal from './SuccessModal';

const ResetPassword = (props) => {
  const [error, setError] = useState(false);
  const [errorDesc, setErrorDesc] = useState('');
  const [isValid, setIsValid] = useState(true);
  const [success, setSuccess] = useState(false);
  const handleClose = () => setSuccess(false); 
  const [redirect, setRedirect] = useState(false);
  const [passwords, setPasswords] = useState({pass1: '', pass2: ''});

  const { pass1, pass2 } = passwords;
  
  const search = props.location.search;
  const token = new URLSearchParams(search).get('token');
  const email = new URLSearchParams(search).get('email');
    
  useEffect(() => {
      if (!token || !email) {
          setIsValid(false);
      }

      verifyPasswordReset(token, email).then(res => {
          if (res.error) {
              setIsValid(false);
          }
      });
  
  },[]);

  const showError = () => (
        <div className="rounded-md bg-red-50 p-4" style={{display: error ? '' : 'none'}}>
      <div className="flex">
        <div className="flex-shrink-0">
          <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <div className="mt-2 text-sm text-red-700">
              <p className='pl-5 space-y-1'>{errorDesc}</p>
          </div>
        </div>
      </div>
    </div>
  );

  const handleChange = name => event => {
      setPasswords({...passwords, [name]: event.target.value})
  };

    const handleValidation = () => {
        if (!pass1 || !pass2) {
            setError(true);
            setErrorDesc('Passwords cannot be empty');
            return false;
        }
        else {
            if (!pass1.match('^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z].*[a-z].*[a-z]).{8,}$')) {
                setError(true);
                setErrorDesc('Password must contain an uppercase, at least one special character, at least one digit, at least 3 lowercase letters, and at least 8 characters long');
                return false;
           }
        }

        return true;
    };

  const clickSubmit = async (event) => {
      await event.preventDefault();
      await setError(false);

      if (pass1 != pass2) {
          await setError(true);
          await setErrorDesc('Make sure the passwords match');
      }
      else {
          if (!handleValidation()) {
              return
          }
          resetPassword(token, email, pass1).then(res => {
              if (res.error) {
                  setError(true);
                  setErrorDesc(res.error);
              }
              else {
                  setSuccess(true);
              }
          });
      }

  };

  const redirectUser = () => {
      if (redirect) {
          return <Redirect to='/'/>
      }
  };

 if (isValid) {
  return (
    <Layout>
          <SuccessModal title='Password successfully changed!' description='' open={success} handleClose={handleClose}/>
      {redirectUser()}
      <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Reset Password</h2>
          <p className="mt-2 text-center text-sm text-gray-600">
              Please enter a new password
          </p>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            {showError()}
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
              <div>
                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                  Password
                </label>
                <div className="mt-1">
                  <input
                    id="password"
                    onChange={handleChange('pass1')}
                    value={pass1}
                    name="password"
                    type="password"
                    required
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  />
                </div>

                <label htmlFor="retype-password" className="block text-sm font-medium text-gray-700">
                  Re-type Password
                </label>
                <div className="mt-1">
                  <input
                    id="retype-password"
                    onChange={handleChange('pass2')}
                    value={pass2}
                    name="retype-password"
                    type="password"
                    required
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  />
                </div>
                  <button onClick={clickSubmit}> Submit </button>
              </div>
            </div>
          </div>
        </div>
    </Layout>
 
  );
 }
    else {
        return (
            <Layout>
          <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
              <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Password reset link invalid </h2>
              <p className="mt-2 text-center text-sm text-gray-600">
                  Please go back and click 'Forgot password' again
              </p>
            </div>
            </div>
            </Layout>
        );
    }


};

export default ResetPassword;
